export default {
      id: "oc-icon_menu-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_menu",
      toString: function () {
        return this.url;
      }
    }